import get from "lodash/get";
import requireAuth from "shared/Auth/requireAuth";

const requireExternalAuth = requireAuth({
    accountRole: "applicant",
    reqVerification: true,
    redirectPath(props) {
        const universitySlug = props.match.params.universitySlug;
        const colourCode = props.match.params.colourCode;
        return `/${universitySlug}/colour/${colourCode}/external/auth/register`;
    },
    verifyRedirectPath(props) {
        const universitySlug = get(props, "match.params.universitySlug", "");
        const colourCode = get(props, "match.params.colourCode", "");
        return `/${universitySlug}/colour/${colourCode}/external/auth/verify`;
    },
});

export default requireExternalAuth;
